{
  "title": "Liste de surveillance",
  "header": {
    "collapse": "Réduire",
    "expand": "Développer",
    "approaching_one": "{{count}} en approche",
    "approaching_other": "{{count}} en approche",
    "thresholdSummary": "Comptes à moins de {{percent}} % du seuil de dérive — à surveiller, aucune action requise aujourd'hui"
  },
  "table": {
    "portfolio": "Portefeuille",
    "accountType": "Type de compte",
    "reason": "Raison",
    "custodian": "Dépositaire",
    "value": "Valeur",
    "bandConsumed": "Bande consommée",
    "threshold": "Seuil"
  },
  "empty": {
    "title": "Aucun compte n'approche le seuil."
  },
  "footer": {
    "configure": "Configurer",
    "rowCount_one": "Affichage de {{count}} compte",
    "rowCount_other": "Affichage de {{count}} comptes",
    "threshold": "Seuil : {{percent}} % de bande consommée"
  },
  "triggers": {
    "cashDeposit": "Dépôt de trésorerie",
    "extTransfer": "Virement externe",
    "sectorConcentration": "Concentration sectorielle",
    "dividendReinvestment": "Réinvestissement des dividendes",
    "cashBand": "Bande de trésorerie",
    "positionBand": "Bande de position"
  }
}
